import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputUI } from "@parkschannel/ui";
import React from "react";
import { useFieldContext } from "../Form";
export function TextAreaField(param) {
    let { withCounter =false , maxLength , ...rest } = param;
    const { field  } = useFieldContext();
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative ",
        children: [
            /*#__PURE__*/ _jsx(InputUI.TextArea, {
                ...field,
                id: field.name,
                ...rest,
                maxLength: maxLength
            }),
            withCounter && field.value && /*#__PURE__*/ _jsxs("div", {
                className: "absolute -bottom-6 right-0 text-black text-xs font-normal mt-2",
                children: [
                    field.value.length,
                    "/",
                    maxLength
                ]
            })
        ]
    });
}
